// BackendPendingBanner — shown when a depended-on endpoint owned
// by the parallel backend agent isn't yet deployed (HTTP 404/501).
// Lets the operator know the feature shipped UI-side but is
// blocked on the backend rather than appearing as a generic
// "Failed: fetch error".
export function BackendPendingBanner({
  feature,
  endpoint,
}: {
  feature: string;
  endpoint?: string;
}) {
  return (
    <div className="rounded border border-amber-700/40 bg-amber-900/10 p-3 text-sm text-amber-200">
      <div className="font-mono text-[10px] uppercase tracking-widest text-amber-300/70 mb-1">
        Backend feature pending
      </div>
      <div>{feature} is wired in the UI but the backend endpoint isn't deployed yet.</div>
      {endpoint && (
        <div className="font-mono text-[10px] text-amber-200/70 mt-1">{endpoint}</div>
      )}
    </div>
  );
}
